import React, { Component } from 'react'

class VstateComponent extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             count:0
        }
    }
    IncrementCounter(){
        // this.setState({
        //     count:this.state.count+1
        // },()=> console.log(this.state.count))
        this.setState((prevState) => ({
            count:prevState.count+1            
        }))
    }
    IncrementFiveCounter(){
        this.IncrementCounter()
        this.IncrementCounter()
        this.IncrementCounter()
        this.IncrementCounter()
        this.IncrementCounter()
    }
    
    render() {
        return (
            <div>
                 <div>
                <button onClick={()  => this.IncrementCounter()} >Increment Counter </button>
                <button onClick={()  => this.IncrementFiveCounter()} >Increment  Five Time  </button><br/>
                <label>Increment  Button is Clicked : <b>{this.state.count }</b></label> 
                  </div>
            </div>
        )
    }
}

export default VstateComponent
